import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import ModalChoosing from "./ModalChoosing";
import ModalReason from "./ModalReason";
import toast from "react-hot-toast";
import ModalFinish from "./ModalFinish";

const reorder = (list: any, startIndex: any, endIndex: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const move = (
  source: any,
  destination: any,
  droppableSource: any,
  droppableDestination: any
) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);
  destClone.splice(droppableDestination.index, 0, removed);
  const result: any = {};
  result["source"] = sourceClone;
  result["destination"] = destClone;

  return result;
};

const grid = 8;

const getListStyle = (isDraggingOver: any) => ({
  background: isDraggingOver ? "lightblue" : "",
  padding: grid,
  height: "100%",
  "min-height": "90vh",
  // width: 200,
});

const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getEmployeeListStyle = (isDraggingOver: any) => ({
  background: isDraggingOver ? "lightblue" : "",
  // padding: grid,
  display: "flex",
  // marginLeft : "10px"
});

const getEmployeeItemStyle = (isDragging: any, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,
  height: "100%",
  // change background colour if dragging
  background: isDragging ? "lightgreen" : "",

  // styles we need to apply on draggables

  ...draggableStyle,
});

export default function OutletAssign(props: any) {
  const [selected_filter, setSelectedFilter] = useState({
    id: "all",
    name: "all",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [unassigned_services, SetUnassignedServices] = useState([]);
  const [unassigned_reworks, SetUnassignedReworks] = useState([]);
  const [services, SetServices] = useState([]);
  const [users, SetUsers] = useState([]);
  const [service_providers, SetServiceProviders] = useState([]);
  const [is_open, SetIsOpen] = useState(false);
  const [is_click, SetIsclick] = useState(false);
  const [is_click_service, SetIsclickService] = useState(false);
  const [is_click_rework, SetIsclickRework] = useState(false);
  const [choosing_modal, SetChoosingModal] = useState({
    open: false,
    type: "service",
    task_data: {},
    emp_data: {},
    assigned_services: [],
    to: "assign",
    selected_filter: {},
  });

  const [reason_modal, SetReasonModal] = useState({
    is_open: false,
    data: {},
  });

  const [finish_modal, SetFinishModal] = useState({
    open: false,
    data: {},
  });

  useEffect(() => {
    console.log("OutletAssign On mount :", props);
    get_init(selected_filter);
  }, []);

  //
  async function get_init(data: any) {
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };
    // if (data.id != 0) {
    //   pass_data.get.service_id = data.id;
    // }
    // if (task_filter.id != 0) {
    //   pass_data.get.task_id = task_filter.id;
    // }
    if (data.name == "service") {
      pass_data.get.service_id = data.id;
    } else if (data.name == "task") {
      pass_data.get.task_id = data.id;
    }

    let response = await api("/editortask/assign_task_init", pass_data);
    console.log("assign_task_init :", response);
    if (response.response.hasOwnProperty("unassigned_services")) {
      SetUnassignedServices(response.response.unassigned_services);
    }
    if (response.response.hasOwnProperty("unassigned_reworks")) {
      SetUnassignedReworks(response.response.unassigned_reworks);
    }
    if (response.response.hasOwnProperty("services")) {
      SetServices(response.response.services);
    }
    if (response.response.hasOwnProperty("service_providers")) {
      // SetUsers(response.response.users);
      SetUsers(response.response.service_providers);
      SetServiceProviders(response.response.service_providers);
    }
  }

  function OnDragStop(result: any) {
    const { source, destination } = result;
    console.log(" OnDragStop result :", result);
    if (!destination) {
      return;
    }
    const sInd = source.droppableId;
    const dInd = destination.droppableId;
    console.log("sInd :", sInd);
    console.log("dInd :", dInd);

    if (sInd == dInd) {
      console.log("sInd === dInd ");
      if (sInd == "users" && dInd == "users") {
        console.log("Emp Card Change : RE-ORDER");
        const items: any = reorder(users, source.index, destination.index);
        console.log("users :", items);
        SetUsers(items);
      } else if (
        sInd == "unassigned_services" &&
        dInd == "unassigned_services"
      ) {
        console.log("unassigned_services order change : RE-ORDER");
        const items: any = reorder(
          unassigned_services,
          source.index,
          destination.index
        );
        console.log("unassigned_services :", items);
        SetUnassignedServices(items);
      } else if (sInd == "unassigned_reworks" && dInd == "unassigned_reworks") {
        console.log("unassigned_reworks order change : RE-ORDER");
        const items: any = reorder(
          unassigned_reworks,
          source.index,
          destination.index
        );
        console.log("unassigned_reworks :", items);
        SetUnassignedReworks(items);
      } else {
        console.log("Emp order change : RE-ORDER");
        change_service_order(result);
      }
    } else {
      console.log("sInd != dInd");

      if (sInd == "unassigned_services" && dInd != "unassigned_reworks") {
        console.log("Service tab to emp tab");
        assign("service", result);
      }

      if (sInd == "unassigned_reworks" && dInd != "unassigned_services") {
        console.log("rework tab to emp tab");
        assign("rework", result);
      }

      if (
        sInd != "unassigned_services" &&
        sInd != "unassigned_reworks" &&
        dInd != "unassigned_services" &&
        dInd != "unassigned_reworks"
      ) {
        console.log("emp tab to emp tab");
        change_service(result);
      }

      if (
        sInd != "unassigned_services" &&
        sInd != "unassigned_reworks" &&
        dInd == "unassigned_services"
      ) {
        console.log("emp tab to unassigned_services tab");
        on_unassign(result);
      }

      if (
        sInd != "unassigned_services" &&
        sInd != "unassigned_reworks" &&
        dInd == "unassigned_reworks"
      ) {
        console.log("emp tab to unassigned_reworks tab");
        on_unassign(result);
      }
    }
  }

  async function on_unassign(result: any) {
    console.log("on_unassign result :", result);
    const { source, destination } = result;
    let source_index, destination_index;
    let emp_data: any = users;
    source_index = result.source.droppableId.substring(13);
    destination_index = result.destination.droppableId.substring(13);
    let service_index = result.source.index;
    let service_data = emp_data[source_index].assigned_services[service_index];
    console.log("service_data :", service_data);

    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        task_assigned_id: service_data.id,
        sp_id: emp_data[source_index].id,
      },
    };

    if (selected_filter.name == "service") {
      pass_data.get.service_id = selected_filter.id;
    } else if (selected_filter.name == "task") {
      pass_data.get.task_id = selected_filter.id;
    }

    console.log("pass_data :", pass_data);
    let response = await api("/editortask/unassign", pass_data);
    console.log("unassign_service rework :", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status == "success") {
        SetUnassignedServices(response.response.unassigned_services);
        SetUnassignedReworks(response.response.unassigned_reworks);
        SetServices(response.response.services);
        SetUsers(response.response.service_providers);
        SetServiceProviders(response.response.service_providers);
      }
    }
  }

  async function change_service(result: any) {
    console.log("change_service :", result);
    const { source, destination } = result;
    let source_index, destination_index, emp_data: any;
    emp_data = users;
    source_index = result.source.droppableId.substring(13);
    destination_index = result.destination.droppableId.substring(13);
    if (!emp_data[destination_index].hasOwnProperty("assigned_services")) {
      emp_data[destination_index].assigned_services = [];
    }
    const move_result = move(
      emp_data[source_index].assigned_services,
      emp_data[destination_index].assigned_services,
      source,
      destination
    );
    console.log("move_result :", move_result);
    let to_tasks_value: any = [];
    move_result.destination.map((r_ele: any) => {
      let value: any = {};
      if (r_ele.hasOwnProperty("rework_task_id")) {
        value.rework_id = r_ele.rework_task_id;
      } else {
        value.id = r_ele.service_task_id;
      }
      to_tasks_value.push(value);
    });
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        from_sp_id: emp_data[source_index].id,
        to_sp_id: emp_data[destination_index].id,
        to_tasks: to_tasks_value,
      },
    };
    if (
      emp_data[source_index].assigned_services[source.index].hasOwnProperty(
        "rework_task_id"
      )
    ) {
      pass_data.post.rework_task_id =
        emp_data[source_index].assigned_services[source.index].rework_task_id;
    } else {
      pass_data.post.service_task_id =
        emp_data[source_index].assigned_services[source.index].service_task_id;
    }

    if (selected_filter.name == "service") {
      pass_data.get.service_id = selected_filter.id;
    } else if (selected_filter.name == "task") {
      pass_data.get.task_id = selected_filter.id;
    }

    console.log("pass_data :", pass_data);

    let response = await api("/editortask/swap", pass_data);
    console.log("editortask swap:", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status == "success") {
        SetUnassignedServices(response.response.unassigned_services);
        SetUnassignedReworks(response.response.unassigned_reworks);
        SetServices(response.response.services);
        SetUsers(response.response.service_providers);
        SetServiceProviders(response.response.service_providers);
      }
    }
  }

  async function change_service_order(result: any) {
    const { source, destination } = result;
    let emp_data_index: any = result.source.droppableId.substring(13);
    let emp_data: any = users;
    const reordered_items = reorder(
      emp_data[emp_data_index].assigned_services,
      source.index,
      destination.index
    );
    let all_task_value: any = [];
    reordered_items.map((r_ele: any) => {
      let value: any = {};
      if (r_ele.hasOwnProperty("rework_task_id")) {
        value.rework_id = r_ele.rework_task_id;
      } else {
        value.id = r_ele.service_task_id;
      }
      all_task_value.push(value);
    });
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        sp_id: emp_data[emp_data_index].id,
        all_tasks: all_task_value,
      },
    };

    if (selected_filter.name == "service") {
      pass_data.get.service_id = selected_filter.id;
    } else if (selected_filter.name == "task") {
      pass_data.get.task_id = selected_filter.id;
    }

    console.log("pass_data :", pass_data);
    let response = await api("/editortask/update_priority", pass_data);
    console.log(" editortask update_priority :", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status == "success") {
        SetUnassignedServices(response.response.unassigned_services);
        SetUnassignedReworks(response.response.unassigned_reworks);
        SetServices(response.response.services);
        SetUsers(response.response.service_providers);
        SetServiceProviders(response.response.service_providers);
      }
    }

    //////////////////////// OLD 19-03-2022

    // const { source, destination } = result;
    // let employee_data_index = result.source.droppableId.substring(13);
    // let employee_data: any = users;
    // const items = reorder(
    //   employee_data[employee_data_index].assigned_services,
    //   source.index,
    //   destination.index
    // );
    // console.log("reorder result :", items);
    // let post_data_value: any = {
    //   user_id: "",
    //   all_services: [],
    // };
    // post_data_value.user_id = employee_data[employee_data_index].id;
    // items.map((item: any, index: any) => {
    //   let value: any = {};
    //   if (item.hasOwnProperty("rework_id")) {
    //     value.rework_id = item.rework_id;
    //   } else {
    //     value.id = item.order_service_id;
    //   }
    //   post_data_value.all_services.push(value);
    // });
    // console.log("post_data_value :", post_data_value);
    // let pass_data = {
    //   get: {
    //     brand: id_value.brand_id,
    //     outlet: id_value.outlet_id,
    //   },
    //   post: post_data_value,
    // };
    // let response = await api("/outlet/update_service_priority", pass_data);
    // console.log("update_service_priority :", response);
  }

  async function assign(type: any, result: any) {
    console.log("assign type :", type);
    console.log("assign result :", result);

    const { source, destination } = result;
    let source_index,
      destination_index,
      emp_data: any,
      task_data: any,
      tasks_data: any,
      assigned_services_data: any;
    source_index = result.source.droppableId;
    destination_index = result.destination.droppableId.substring(13);
    emp_data = users[destination_index];
    console.log("assign emp_data :", emp_data);
    if (type == "service") {
      task_data = unassigned_services[source.index];
      tasks_data = unassigned_services;
    } else {
      task_data = unassigned_reworks[source.index];
      tasks_data = unassigned_reworks;
    }
    console.log("task_data :", task_data);
    if (emp_data.hasOwnProperty("assigned_services")) {
      assigned_services_data = emp_data.assigned_services;
    } else {
      assigned_services_data = [];
    }
    const move_result: any = move(
      tasks_data,
      assigned_services_data,
      source,
      destination
    );
    console.log("move_result :", move_result);

    let valid_index = emp_data.valid_tasks.findIndex(
      (ele: any) => ele == task_data.task_id
    );

    console.log("valid_index :", valid_index);
    if (valid_index != -1) {
      SetChoosingModal((prevValue) => {
        prevValue.open = true;
        prevValue.type = type;
        prevValue.task_data = task_data;
        prevValue.emp_data = emp_data;
        prevValue.assigned_services = move_result.destination;
        prevValue.to = "assign";
        prevValue.selected_filter = selected_filter;

        return { ...prevValue };
      });
    } else {
      // console.log("Not a valid task to add to Service Provider");
      toast.error("Not a valid task to assign this service provider");
    }
  }

  function view_shared(
    user_ele: any,
    user_index: any,
    task_ele: any,
    task_index: any
  ) {
    console.log("user_ele :", user_ele);
    console.log("user_index :", user_index);
    console.log("task_ele :", task_ele);
    console.log("task_index :", task_index);
    SetChoosingModal((prevValue) => {
      prevValue.open = true;
      // prevValue.type = type;
      prevValue.task_data = task_ele;
      prevValue.emp_data = user_ele;
      // prevValue.assigned_services = move_result.destination;
      prevValue.to = "view";
      // prevValue.service_filter = selected_filter;
      return { ...prevValue };
    });
  }

  function seconds_to_hours(value) {
    // var sec_num = parseInt(value, 10);
    // var hours = Math.floor(sec_num / 3600);
    // var minutes = Math.floor((sec_num - hours * 3600) / 60);
    // var seconds = sec_num - hours * 3600 - minutes * 60;

    // // if (hours < 10) {
    // //   hours = "0" + hours;
    // // }
    // if (minutes < 10) {
    //   minutes = "0" + minutes;
    // }
    // if (seconds < 10) {
    //   seconds = "0" + seconds;
    // }
    // return hours + ":" + minutes;

    let sec_num = parseInt(value, 10);
    let hours = parseInt(sec_num / 3600);
    let minutes = parseInt((sec_num - hours * 3600) / 60);

    return hours + ":" + Math.abs(minutes);
  }

  function finish_task(ele_value) {
    console.log("finish_task");
    SetFinishModal((prevValue: any) => {
      prevValue.open = true;
      prevValue.data = ele_value;
      return { ...prevValue };
    });
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4 d-flex">
        <h5 className="  mb-0 text-dark fw-bolder">Assign Services</h5>
        <div
          className="d-flex align-items-center ms-auto cursor"
          onClick={() => {
            SetIsOpen(true);
          }}
        >
          <img
            src={require("../../../assets/icon/svg/sliders1.svg")}
            className="pe-2"
          />
          <p className="mb-0">Filter</p>
        </div>
      </div>

      <div className="container-fuild p-3">
        <div className="d-flex own-drag-container ">
          <DragDropContext onDragEnd={OnDragStop}>
            <div
              className={is_click ? "assign_card click-hide" : "assign_card"}
            >
              <div
                className="pe-2"
                onClick={() => {
                  SetIsclick(!is_click);
                }}
              >
                {is_click ? (
                  <i className="far fa-eye cursor"></i>
                ) : (
                  <i className="fas fa-eye-slash cursor"></i>
                )}
              </div>
              <div className="assign_service d-flex mt-2">
                <Droppable
                  key={"unassigned_services"}
                  droppableId={"unassigned_services"}
                  className="unassigned_services"
                >
                  {(provided: any, snapshot: any) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                      {...provided.droppableProps}
                      className={is_click_service ? "click-sub-hide" : ""}
                    >
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          SetIsclickService(!is_click_service);
                        }}
                      >
                        {is_click_service ? (
                          <i className="far fa-eye cursor"></i>
                        ) : (
                          <i className="fas fa-eye-slash cursor"></i>
                        )}
                        <h6 className="ps-2 mb-0">Unassigned Services</h6>
                      </div>
                      {unassigned_services.map(
                        (ua_service_ele: any, ua_service_ele_index: any) => (
                          <Draggable
                            key={ua_service_ele.id}
                            draggableId={"ua_service" + ua_service_ele.id}
                            index={ua_service_ele_index}
                          >
                            {(provided: any, snapshot: any) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )}
                                className="un_service_data p-3 mt-4"
                              >
                                <div className="d-flex align-items-center pb-2">
                                  <div className="">
                                    <p className="mb-2">
                                      {ua_service_ele.task_name}
                                    </p>
                                    <p className="mb-0 fs-12">
                                      {ua_service_ele.service_name}
                                    </p>
                                    <p className="mb-0">
                                      {ua_service_ele.event_name}
                                    </p>
                                  </div>
                                  <div className="ms-auto text-end p-0">
                                    <small className="v-small">
                                      #{ua_service_ele.id}
                                    </small>
                                  </div>
                                </div>
                                <span>{ua_service_ele.client_name}</span>
                                <br></br>
                                <small>{ua_service_ele.company}</small>
                              </div>
                            )}
                          </Draggable>
                        )
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>

                <Droppable
                  key={"unassigned_reworks"}
                  droppableId={"unassigned_reworks"}
                >
                  {(provided: any, snapshot: any) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                      {...provided.droppableProps}
                      className={is_click_rework ? "click-sub-hide" : ""}
                    >
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          SetIsclickRework(!is_click_rework);
                        }}
                      >
                        {is_click_rework ? (
                          <i className="far fa-eye cursor"></i>
                        ) : (
                          <i className="fas fa-eye-slash cursor"></i>
                        )}
                        <h6 className="ps-2 mb-0">Unassigned Reworks</h6>
                      </div>
                      {unassigned_reworks.map(
                        (ua_rework_ele: any, ua_rework_ele_index: any) => (
                          <Draggable
                            key={ua_rework_ele.id}
                            draggableId={"ua_rework" + ua_rework_ele.id}
                            index={ua_rework_ele_index}
                          >
                            {(provided: any, snapshot: any) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )}
                                className="un_rework_data mt-4"
                              >
                                <div className="d-flex align-items-center pb-2">
                                  <div className="">
                                    <p className="mb-2">
                                      {ua_rework_ele.task_name}
                                    </p>
                                    <p className="mb-0 fs-12">
                                      {ua_rework_ele.service_name}
                                    </p>
                                    <p className="mb-0">
                                      {ua_rework_ele.event_name}
                                    </p>
                                  </div>
                                  <div className="ms-auto text-end  p-0">
                                    <small className="v-small">
                                      #{ua_rework_ele.id}
                                    </small>
                                  </div>
                                </div>
                                <span>{ua_rework_ele.client_name}</span>
                                <br></br>
                                <small>{ua_rework_ele.company}</small>
                              </div>
                            )}
                          </Draggable>
                        )
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </div>
            <Droppable
              key={"users"}
              droppableId={"users"}
              type="COLUMN"
              direction="horizontal"
            >
              {(provided: any, snapshot: any) => (
                <div
                  ref={provided.innerRef}
                  style={getEmployeeListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                  className="scrollx"
                >
                  {users.map((user_ele: any, user_index: any) => (
                    <div key={user_index} className="w-draggable">
                      <Draggable
                        key={user_index}
                        draggableId={"UserDragable" + user_index}
                        index={user_index}
                      >
                        {(provided: any, snapshot: any) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getEmployeeItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                            className="pt-0"
                          >
                            <Droppable
                              key={"UserDroppable" + user_index}
                              droppableId={"UserDroppable" + user_index}
                            >
                              {(provided: any, snapshot: any) => (
                                <div
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}
                                  {...provided.droppableProps}
                                  className="panel-container"
                                >
                                  <h6 className="pt-2 pb-2">{user_ele.name}</h6>
                                  {user_ele.hasOwnProperty("assigned_services")
                                    ? user_ele.assigned_services.map(
                                        (task_ele: any, task_index: any) => (
                                          <Draggable
                                            key={task_ele.id}
                                            draggableId={task_ele.id}
                                            index={task_index}
                                          >
                                            {(provided: any, snapshot: any) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps.style
                                                )}
                                                className={
                                                  task_ele.status == "Accepted"
                                                    ? "panel acc_panel active user_data mt-2"
                                                    : task_ele.status ==
                                                      "Unaccepted"
                                                    ? "panel unacc_panel active user_data mt-2"
                                                    : task_ele.status ==
                                                      "Paused"
                                                    ? "panel pause_panel active user_data mt-2"
                                                    : task_ele.status ==
                                                      "Finished"
                                                    ? "panel fini_panel active user_data mt-2"
                                                    : task_ele.status ==
                                                      "Working"
                                                    ? "panel working_panel active user_data mt-2"
                                                    : task_ele.status ==
                                                      "Work Resumed"
                                                    ? "panel resume_panel active user_data mt-2"
                                                    : "panel"
                                                }
                                              >
                                                <div className="panel-header">
                                                  <div className="d-flex align-items-center">
                                                    <p className="mb-1 text-dark">
                                                      <b>
                                                        {task_ele.client_name}
                                                      </b>
                                                    </p>
                                                    <p className=" ms-auto mb-0">
                                                      {task_ele.task_name}
                                                    </p>
                                                  </div>
                                                  <div className="d-flex">
                                                    <p className="text-dark mt-2 fs-12">
                                                      <b>
                                                        {task_ele.service_name}
                                                      </b>
                                                    </p>
                                                    <div className="text-dark mt-2 fs-12 ms-auto d-flex">
                                                      {task_ele.hasOwnProperty(
                                                        "status"
                                                      ) ? (
                                                        <>
                                                          <i
                                                            className=" ps-2 pt-1 pe-2 fas fa-exclamation-circle"
                                                            style={{
                                                              color:
                                                                task_ele.status ==
                                                                "Accepted"
                                                                  ? "#0018cc"
                                                                  : task_ele.status ==
                                                                    "Unaccepted"
                                                                  ? "#cc0000"
                                                                  : task_ele.status ==
                                                                    "Paused"
                                                                  ? "#dfd800"
                                                                  : task_ele.status ==
                                                                    "Finished"
                                                                  ? "#008017"
                                                                  : task_ele.status ==
                                                                    "Working"
                                                                  ? "#00adcc"
                                                                  : task_ele.status ==
                                                                    "Work Resumed"
                                                                  ? "#ab00a8"
                                                                  : "white",
                                                            }}
                                                          ></i>
                                                          <p>
                                                            <b>
                                                              {task_ele.status}
                                                            </b>
                                                          </p>
                                                        </>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="panel-body">
                                                  <p className="text-dark mt-2 mb-1">
                                                    <b>{task_ele.event_name}</b>
                                                  </p>
                                                  <p className="text-dark mt-2 mb-1">
                                                    <b>{task_ele.company}</b>
                                                  </p>

                                                  <div>
                                                    {task_ele.hasOwnProperty(
                                                      "max_working_hours"
                                                    ) ? (
                                                      <p className="text-dark mt-2 mb-1">
                                                        Total Working :
                                                        <b>
                                                          {
                                                            task_ele.max_working_hours
                                                          }
                                                        </b>
                                                      </p>
                                                    ) : null}
                                                    {task_ele.hasOwnProperty(
                                                      "worked_duration"
                                                    ) ? (
                                                      <p className="text-dark mt-2 mb-1">
                                                        Worked :
                                                        <b>
                                                          {seconds_to_hours(
                                                            task_ele.worked_duration
                                                          )}{" "}
                                                          Hours
                                                        </b>
                                                      </p>
                                                    ) : null}
                                                    {task_ele.hasOwnProperty(
                                                      "remaining_duration"
                                                    ) ? (
                                                      <p className="text-dark mt-2 mb-1">
                                                        Remaining :
                                                        <b>
                                                          {seconds_to_hours(
                                                            task_ele.remaining_duration
                                                          )}{" "}
                                                          Hours
                                                        </b>
                                                      </p>
                                                    ) : null}
                                                  </div>

                                                  <div className="d-flex mb-2">
                                                    {task_ele.hasOwnProperty(
                                                      "paused_reason"
                                                    ) ? (
                                                      <p
                                                        className="mb-0 p-1 text-primary cursor ms-auto text-end"
                                                        onClick={() => {
                                                          console.log(
                                                            "View Reason"
                                                          );
                                                          SetReasonModal(
                                                            (
                                                              prevValue: any
                                                            ) => {
                                                              prevValue.is_open =
                                                                true;
                                                              prevValue.data =
                                                                task_ele;
                                                              return {
                                                                ...prevValue,
                                                              };
                                                            }
                                                          );
                                                        }}
                                                      >
                                                        View Reason
                                                      </p>
                                                    ) : null}
                                                    <p
                                                      className="text-primary cursor mb-0 p-1 ms-auto text-end"
                                                      onClick={() => {
                                                        console.log(
                                                          "Finish on task :",
                                                          task_ele
                                                        );
                                                        // view_shared(
                                                        //   user_ele,
                                                        //   user_index,
                                                        //   task_ele,
                                                        //   task_index
                                                        // );
                                                        finish_task(task_ele);
                                                      }}
                                                    >
                                                      Finish
                                                    </p>
                                                    <p
                                                      className="text-primary cursor mb-0 p-1 ms-auto text-end"
                                                      onClick={() => {
                                                        console.log(
                                                          "view Shared on task :",
                                                          task_ele
                                                        );
                                                        view_shared(
                                                          user_ele,
                                                          user_index,
                                                          task_ele,
                                                          task_index
                                                        );
                                                      }}
                                                    >
                                                      View Shared
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        )
                                      )
                                    : null}

                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </div>
                        )}
                      </Draggable>
                    </div>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>

      <ModalChoosing
        data={choosing_modal}
        close={(data: any) => {
          console.log("ModalChoosing on close :", data);
          SetChoosingModal((prevValue) => {
            prevValue.open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            SetUnassignedServices(data.unassigned_services);
            SetUnassignedReworks(data.unassigned_reworks);
            SetServices(data.services);
            SetUsers(data.service_providers);
            SetServiceProviders(data.service_providers);
          }
          console.log("selected_filter on modal close :", selected_filter);
          // get_init(selected_filter);
        }}
      />

      <ModalFinish
        data={finish_modal}
        close={(data: any) => {
          console.log("ModalChoosing on close :", data);
          SetFinishModal((prevValue) => {
            prevValue.open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            get_init(selected_filter);
          }
        }}
      />

      <ModalReason
        open={reason_modal.is_open}
        data={reason_modal.data}
        close={() => {
          SetReasonModal((prevValue: any) => {
            prevValue.is_open = false;
            prevValue.data = "";
            return {
              ...prevValue,
            };
          });
        }}
      />

      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        title="Filters"
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          SetIsOpen(false);
        }}
        from="right"
        width="500px"
      >
        <div className="p-2">
          <p>Select filter</p>

          <div className="p-1 row">
            <div
              className="md-radio md-radio-inline col-md-6 pb-3 pt-md-0"
              onClick={() => {
                let data = { id: "all", name: "all" };
                setSelectedFilter(data);
                get_init(data);
                SetIsOpen(false);
              }}
            >
              <input
                type="radio"
                value="all"
                checked={selected_filter.id === "all"}
                onChange={() => {
                  console.log("hai");
                }}
              />
              <label className="text-dark">All</label>
            </div>

            {services.map((f_ele: any, f_index: any) => (
              <div key={f_index}>
                {/* <p>Services</p> */}
                <div
                  className="md-radio md-radio-inline col-md-6 pb-2 pt-md-0"
                  key={f_index}
                  onClick={() => {
                    let data = { id: f_ele.id, name: "service" };
                    setSelectedFilter(data);
                    get_init(data);
                    SetIsOpen(false);
                  }}
                >
                  <input
                    type="radio"
                    value={f_ele.name}
                    checked={selected_filter.id === f_ele.id}
                    onChange={() => {
                      console.log("hai");
                    }}
                  />
                  <label className="text-dark">{f_ele.name}</label>
                </div>
                <div className="ms-5">
                  {/* <p>Tasks</p> */}
                  {f_ele.tasks.map((task_ele: any, task_index: any) => (
                    <div
                      className="md-radio md-radio-inline col-md-6 pb-3 p-0 pt-md-0"
                      key={task_index}
                      onClick={() => {
                        let data = { id: task_ele.id, name: "task" };
                        setSelectedFilter(data);
                        get_init(data);
                        SetIsOpen(false);
                      }}
                    >
                      <input
                        type="radio"
                        value={task_ele.name}
                        checked={selected_filter.id === task_ele.id}
                        onChange={() => {
                          console.log("hai");
                        }}
                      />
                      <label className="text-gray pe-2">{task_ele.name}</label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </SlidingPane>
    </div>
  );
}
